import { useDevice } from 'platform/foundation-tw';
export function useIsMobileView() {
  const device = useDevice();
  return device === "mobile";
}